import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

export const initSentry = (dsn, environment, release, tracesSampleRate, ignoreErrors, allowUrls) => {
    Sentry.init({
        dsn,
        environment,
        release,
        tracesSampleRate,
        allowUrls,
        ignoreErrors,
        integrations: [new Integrations.BrowserTracing()],
    });
};
